export default "__VITE_ASSET__NYYHvNaZ__"